module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pop-up-ads-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Pop Up Ads',
          to: {
            path: '/pop-up-ads'
          },
          exact: true,
        },
        {
          text: _vm.$route.query.id ?
            'Ubah Pop Up Ads' :
            'Tambah Pop Up Ads',
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(_vm.$route.query.id ? "Ubah" : "Tambah") + " Pop Up Ads\n    ")]), _vm._v(" "), _c('v-card', {
    staticStyle: {}
  }, [_c('v-card-title', [_vm._v(" Detail Pop Up Ads ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card', {
    staticClass: "d-flex",
    attrs: {
      "flat": ""
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-card', {
    staticClass: "border-bottom-divider rounded-tl pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    key: _vm.keyimg,
    attrs: {
      "src": _vm.url ?
        _vm.url :
        _vm.data.image && _vm.data.image != '' ?
        _vm.data.image :
        require('@/assets/img/image_unavailable.png')
    }
  })])])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-btn', {
    staticClass: "pa-0 mt-5 font-weight-bold",
    attrs: {
      "block": "",
      "color": "success",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.uploader.click()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("mdi-file-upload")]), _vm._v("\n                            Upload\n                        ")], 1), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-caption pa-0 d-flex justify-center"
  }, [_vm._v("\n                        Ukuran gambar 400 x 500\n                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-caption pa-0 d-flex justify-center"
  }, [_vm._v("\n                        Maximum size is 300 KB\n                    ")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "border-left": "1px solid #f0f0f0"
    },
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pb-2"
  }, [_vm._v("\n                                    Nama Ads\n                                    "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Nama Ads",
      "required": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.$set(_vm.data, "name", $$v)
      },
      expression: "data.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pb-2"
  }, [_vm._v("\n                                    Deskripsi\n                                    "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "placeholder": "Deskripsi Kelas",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.data.deskripsi),
      callback: function($$v) {
        _vm.$set(_vm.data, "deskripsi", $$v)
      },
      expression: "data.deskripsi"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pb-2"
  }, [_vm._v("\n                                    URL "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "https://",
      "required": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.data.url),
      callback: function($$v) {
        _vm.$set(_vm.data, "url", $$v)
      },
      expression: "data.url"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pb-2"
  }, [_vm._v("\n                                    Deeplink URL\n                                    "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "https://",
      "required": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.data.deeplink),
      callback: function($$v) {
        _vm.$set(_vm.data, "deeplink", $$v)
      },
      expression: "data.deeplink"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pb-2"
  }, [_vm._v("\n                                    Page Direction\n                                    "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "https://",
      "required": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.data.page_direction),
      callback: function($$v) {
        _vm.$set(_vm.data, "page_direction", $$v)
      },
      expression: "data.page_direction"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pb-2"
  }, [_vm._v("\n                                                Waktu Mulai\n                                                "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "id": "tryout_durasi_start_date",
                "append-icon": "mdi-calendar",
                "placeholder": "Tanggal",
                "outlined": "",
                "dense": ""
              },
              model: {
                value: (
                  _vm.startDate.value
                ),
                callback: function($$v) {
                  _vm.$set(_vm.startDate, "value", $$v)
                },
                expression: "\n                                                                        startDate.value\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }]),
    model: {
      value: (
        _vm.startDate.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.startDate, "option", $$v)
      },
      expression: "\n                                                                startDate.option\n                                                            "
    }
  }, [_vm._v(" "), (
    _vm.startDate.option
  ) ? _c('v-date-picker', {
    attrs: {
      "min": new Date()
        .toISOString()
        .slice(
          0,
          10
        ),
      "no-title": "",
      "scrollable": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        _vm.startDate.option = false
      }
    },
    model: {
      value: (
        _vm.startDate.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.startDate, "value", $$v)
      },
      expression: "\n                                                                    startDate.value\n                                                                "
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu1",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "id": "tryout_durasi_start_time",
                "outlined": "",
                "dense": "",
                "placeholder": "Jam",
                "append-icon": "mdi-clock-time-four-outline"
              },
              model: {
                value: (
                  _vm.startTime.value
                ),
                callback: function($$v) {
                  _vm.$set(_vm.startTime, "value", $$v)
                },
                expression: "\n                                                                        startTime.value\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }]),
    model: {
      value: (
        _vm.startTime.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.startTime, "option", $$v)
      },
      expression: "\n                                                                startTime.option\n                                                            "
    }
  }, [_vm._v(" "), (
    _vm.startTime.option
  ) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    on: {
      "change": function($event) {
        _vm.startTime.value =
          _vm.startTime.value ?
          _vm.startTime.value +
          ':00' :
          null
      },
      "click:minute": function($event) {
        return _vm.$refs.menu1.save(
          _vm.startTime.value
        )
      }
    },
    model: {
      value: (
        _vm.startTime.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.startTime, "value", $$v)
      },
      expression: "\n                                                                    startTime.value\n                                                                "
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pb-2"
  }, [_vm._v("\n                                                Waktu Berakhir\n                                                "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "id": "tryout_durasi_end_date",
                "append-icon": "mdi-calendar",
                "placeholder": "Tanggal",
                "outlined": "",
                "dense": ""
              },
              model: {
                value: (
                  _vm.endDate.value
                ),
                callback: function($$v) {
                  _vm.$set(_vm.endDate, "value", $$v)
                },
                expression: "\n                                                                        endDate.value\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }]),
    model: {
      value: (
        _vm.endDate.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.endDate, "option", $$v)
      },
      expression: "\n                                                                endDate.option\n                                                            "
    }
  }, [_vm._v(" "), (
    _vm.endDate.option
  ) ? _c('v-date-picker', {
    attrs: {
      "min": new Date()
        .toISOString()
        .slice(
          0,
          10
        ),
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.endDate.option = false
      }
    },
    model: {
      value: (
        _vm.endDate.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.endDate, "value", $$v)
      },
      expression: "\n                                                                    endDate.value\n                                                                "
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "id": "tryout_durasi_end_time",
                "outlined": "",
                "dense": "",
                "placeholder": "Jam",
                "append-icon": "mdi-clock-time-four-outline"
              },
              model: {
                value: (
                  _vm.endTime.value
                ),
                callback: function($$v) {
                  _vm.$set(_vm.endTime, "value", $$v)
                },
                expression: "\n                                                                        endTime.value\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }]),
    model: {
      value: (
        _vm.endTime.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.endTime, "option", $$v)
      },
      expression: "\n                                                                endTime.option\n                                                            "
    }
  }, [_vm._v(" "), (
    _vm.endTime.option
  ) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    on: {
      "change": function($event) {
        _vm.endTime.value =
          _vm.endTime.value ?
          _vm.endTime.value +
          ':00' :
          null
      },
      "click:minute": function($event) {
        return _vm.$refs.menu.save(
          _vm.endTime.value
        )
      }
    },
    model: {
      value: (
        _vm.endTime.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.endTime, "value", $$v)
      },
      expression: "\n                                                                    endTime.value\n                                                                "
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pb-2"
  }, [_vm._v("\n                                    Status Aktif\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "Aktif",
      "outlined": ""
    },
    model: {
      value: (_vm.data.is_active),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_active", $$v)
      },
      expression: "data.is_active"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pb-2"
  }, [_vm._v("\n                                    Tampilkan di Platform\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "Android",
      "outlined": ""
    },
    model: {
      value: (_vm.data.is_android),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_android", $$v)
      },
      expression: "data.is_android"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "IOS",
      "outlined": ""
    },
    model: {
      value: (_vm.data.is_ios),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_ios", $$v)
      },
      expression: "data.is_ios"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "Webapp",
      "outlined": ""
    },
    model: {
      value: (_vm.data.is_webapp),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_webapp", $$v)
      },
      expression: "data.is_webapp"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "Web Purchase",
      "outlined": ""
    },
    model: {
      value: (_vm.data.is_webpurchase),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_webpurchase", $$v)
      },
      expression: "data.is_webpurchase"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pt-0 px-0 pb-6"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pb-2"
  }, [_vm._v("\n                                    User Group\n                                    "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _vm._l((_vm.data.user_group), function(usgr, i) {
    return _c('v-autocomplete', {
      key: i,
      staticClass: "pb-2",
      attrs: {
        "items": _vm.user_groups,
        "item-text": "user_group_name",
        "item-value": "id",
        "placeholder": "-- Pilih user group --",
        "outlined": "",
        "dense": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function() {
          return [(
            i ===
            _vm.data.user_group.length -
            1 &&
            _vm.data.user_group.length != 1
          ) ? _c('v-btn', {
            staticClass: "font-weight-bold dark--text py-3",
            attrs: {
              "id": "user-remove-scope-btn",
              "dark": "",
              "x-large": "",
              "depressed": "",
              "color": "white",
              "elevation": "1"
            },
            on: {
              "click": function($event) {
                _vm.queryId
                  ?
                  null :
                  _vm.data.user_group.splice(
                    i,
                    1
                  )
              }
            }
          }, [_vm._v("\n                                            Hapus\n                                        ")]) : _vm._e()]
        },
        proxy: true
      }], null, true),
      model: {
        value: (_vm.data.user_group[i]),
        callback: function($$v) {
          _vm.$set(_vm.data.user_group, i, $$v)
        },
        expression: "data.user_group[i]"
      }
    })
  })], 2)], 1), _vm._v(" "), _c('v-container', [_c('v-btn', {
    staticClass: "font-weight-bold blew--text mb-5",
    attrs: {
      "id": "user-add-scope-btn",
      "block": "",
      "depressed": "",
      "color": "#e8f5fa"
    },
    on: {
      "click": function($event) {
        return _vm.data.user_group.push('')
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("\n                                    mdi-plus-circle\n                                ")]), _vm._v("\n                                Tambah User Group Baru\n                            ")], 1), _vm._v(" "), (_vm.$route.query.id) ? _c('v-btn', {
    staticClass: "font-weight-bold blew--text mb-5",
    attrs: {
      "block": "",
      "depressed": "",
      "color": "#e8f5fa"
    },
    on: {
      "click": function($event) {
        (_vm.pushNew(), _vm.fetchData())
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    staticStyle: {
      "font-size": "22px !important"
    }
  }, [_vm._v("\n                                    mdi-sort-bool-ascending-variant\n                                ")]), _vm._v("\n                                Atur Urutan Pop Up Ads\n                            ")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-6 py-2 white--text",
    attrs: {
      "depressed": "",
      "color": "blew",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.putObject()
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.title) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.subtitle) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm.open = false;
        _vm.dialogConfirm.title = null;
        _vm.dialogConfirm.function = null;
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.putObject(1);
        _vm.dialogConfirm.open = false;
        _vm.dialogConfirm.title = null;
        _vm.dialogConfirm.function = null;
      }
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "940px",
      "min-height": "537px",
      "max-height": "771px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.modalUrutan = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', [_vm._v("\n                    Urutan Pop Up Ads\n                    "), (_vm.data.name) ? _c('span', {
          staticClass: "ml-2"
        }, [_vm._v("\n                        (" + _vm._s(_vm.data.name) + ")\n                    ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.loading_sequence) ? _c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "primary",
            "size": 30
          }
        }) : _vm._e(), _vm._v(" "), (_vm.updated_sequence && !_vm.loading_sequence) ? _c('v-icon', {
          staticStyle: {
            "font-size": "32px"
          },
          attrs: {
            "color": "blew"
          }
        }, [_vm._v("mdi-check-circle")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-subtitle', [_c('div', [_vm._v("Atur urutan dengan drag list pop up ads")])]), _vm._v(" "), _c('v-card-text', {
          attrs: {
            "width": "100%"
          }
        }, [_c('div', {
          staticClass: "mt-3 mb-5 pl-4 font-weight-bold"
        }, [
          [_c('v-row', [_c('v-col', {
            attrs: {
              "cols": "2"
            }
          }, [_vm._v("Nomor Urut")]), _vm._v(" "), _c('v-col', {
            attrs: {
              "cols": "8"
            }
          }, [_vm._v("Nama Pop Up Ads")])], 1)]
        ], 2), _vm._v(" "), (_vm.isLoading) ? _c('div', {
          staticClass: "mt-8"
        }, [_c('v-skeleton-loader', _vm._b({
          attrs: {
            "type": "card"
          }
        }, 'v-skeleton-loader', _vm.attrs, false))], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('draggable', {
          staticClass: "list-group",
          attrs: {
            "list": _vm.popup2,
            "ghost-class": "ghost",
            "move": _vm.checkMove
          },
          on: {
            "start": function($event) {
              _vm.dragging = true
            },
            "end": _vm.finishDragged
          }
        }, [_vm._l((_vm.popup2), function(element, index) {
          return _c('div', {
            key: element.id,
            staticClass: "list-group-item pa-6 draggable",
            class: element.id == _vm.$route.query.id ?
              'selected' :
              ''
          }, [_c('v-row', [_c('v-col', {
            attrs: {
              "cols": "2",
              "md": "2"
            }
          }, [_c('v-btn', {
            staticClass: "font-weight-bold",
            staticStyle: {
              "font-size": "14px"
            },
            attrs: {
              "color": element.id ==
                _vm.$route.query.id ?
                '#29b6f6' :
                'blew',
              "rounded": "",
              "fab": "",
              "x-small": "",
              "dark": "",
              "depressed": ""
            }
          }, [_vm._v("\n                                            " + _vm._s(index + 1) + "\n                                        ")])], 1), _vm._v(" "), _c('v-col', {
            staticClass: "pt-1",
            attrs: {
              "cols": "8",
              "md": "8"
            }
          }, [_vm._v("\n                                        " + _vm._s(element.name) + "\n                                    ")])], 1)], 1)
        }), _vm._v(" "), (!_vm.popup2.length) ? _c('div', {
          staticClass: "text-center"
        }, [_vm._v("\n                                Pop Up Ads tidak tersedia\n                            ")]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-simple-table', {
          staticClass: "pa-0",
          staticStyle: {
            "display": "none"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function() {
              return [_c('thead', [_c('tr', [_c('th', {
                staticClass: "text-left"
              }, [_vm._v("Nomor Urut")]), _vm._v(" "), _c('th', {
                staticClass: "text-left",
                attrs: {
                  "width": "80%"
                }
              }, [_vm._v("\n                                        Nama Pop Up Ads\n                                    ")]), _vm._v(" "), _c('th', {
                staticClass: "text-left"
              }, [_vm._v("Aksi")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedPopUp), function(popup, index) {
                return _c('tr', {
                  key: index,
                  attrs: {
                    "color": popup.id == _vm.$route.query.id ||
                      popup.name === _vm.name ?
                      '#F9F9FB' :
                      ''
                  }
                }, [_c('td', [_vm._v(_vm._s(popup.no_urut))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(popup.name))]), _vm._v(" "), _c('td', [(
                  popup.no_urut > 1 &&
                  (popup.id ==
                    _vm.$route.query.id ||
                    popup.new)
                ) ? _c('v-btn', {
                  staticClass: "pa-0",
                  attrs: {
                    "min-width": "32px",
                    "height": "32px",
                    "elevation": "0"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.moveUp(popup)
                    }
                  }
                }, [_c('v-icon', [_vm._v("mdi-menu-up")])], 1) : _vm._e(), _vm._v(" "), (
                  popup.id ==
                  _vm.$route.query.id ||
                  popup.new
                ) ? _c('v-btn', {
                  staticClass: "pa-0",
                  attrs: {
                    "min-width": "32px",
                    "height": "32px",
                    "elevation": "0"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.moveDown(popup)
                    }
                  }
                }, [_c('v-icon', [_vm._v("mdi-menu-down")])], 1) : _vm._e()], 1)])
              }), 0)]
            },
            proxy: true
          }], null, true)
        })], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
          staticClass: "text-h2"
        })]), _vm._v(" "), _c('v-card-actions', {
          staticClass: "justify-end"
        }, [_c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_vm._v("Close")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.modalUrutan),
      callback: function($$v) {
        _vm.modalUrutan = $$v
      },
      expression: "modalUrutan"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b49049e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pop_up_ads/components/PopUpAdsForm.vue
// module id = 2061
// module chunks = 1